import { App_Url } from "@/whiteLable";

export const getInsurerLogo = (name?: string): string => {
  const n = name?.toLowerCase() ?? "";
  const insurerAssets = App_Url.partners.insurers;
  if (n.includes("rak")) return insurerAssets.RakInsurance;
  if (n.includes("dni")) return insurerAssets.DniInsurance;
  if (n.includes("insurehub")) return insurerAssets.AurumInsurance;
  if (n.includes("qic")) return insurerAssets.Qic;
  if (n.includes("gig")) return insurerAssets.Gig;
  if (n.includes("sukoon")) return insurerAssets.Sokoon;
  if (n.includes("salama")) return insurerAssets.Salama;
  if (n.includes("liva")) return insurerAssets.Liva;
  if (n.includes("orient")) return insurerAssets.OrientInsurance;
  if (n.includes("metlife")) return insurerAssets.MetLifeGulf;
  if (n.includes("zurich")) return insurerAssets.ZurichInternationalLife;
  return insurerAssets.Aig;
};
